import { useQuery, useMutation } from '@tanstack/vue-query';
import { downloadFileFromResponse } from '@/utils/download';

import api from './api';

export const useFileById = (id) => {
  return useQuery({
    queryKey: ['file', id],
    queryFn: () => api.getFileById(id),
  });
};

export const useDownloadFileById = () => {
  return useMutation({
    mutationFn: ({ id }) => api.getFileContentById(id),
    onSuccess: (response, variables) => {
      downloadFileFromResponse(response, variables.fileName, variables.contentType);
    },
  });
};
